/**
 * @ngdoc service
 * @name posApp.secondScreen
 * @description
 * Service taking care of communication with the second screen.
 */
angular
  .module('posApp')
  .factory('secondScreen', (printer, settingsManager) => ({
    /**
     * @ngdoc
     * @name posApp.secondScreen#showTransaction
     * @methodOf posApp.secondScreen
     *
     * @description
     * Send transaction data to second screen application using printer queue as
     * means of communication.
     */
    showTransaction: function (transaction: any) {
      // Only only one of the printer queues can be used to update second screen
      const queueName = settingsManager.settings.secondScreen?.secondScreenId;

      if (queueName) {
        const container: any = {
          transaction,
        };

        // allow additional data to be send to ss, such as payment method.
        if (transaction.roundPayment) {
          container.roundPayment = transaction.roundPayment;
        }

        printer.rawPQ2(container, queueName);
      }
    },
  }));
